module.exports = __webpack_public_path__ + "static/media/gametransactionz.650e1847.png";